module.exports = __webpack_public_path__ + "img/logo-footer.d1bf5ccb.png";